import { CaptionBold, H4Bold } from '@comeon/ui';
import styled from 'styled-components';

import { GameTag } from '~/components/casino-shared/types';

const FeaturesContainer = styled.div`
	margin-block: 12px;
`;
const FeaturesTitle = styled(H4Bold)`
	margin-bottom: 6px;
	color: var(--game-info-row-value-text-color);
`;

const FeaturesPillWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
`;
const FeaturePill = styled(CaptionBold)`
	background-color: var(--game-info-card-color);
	color: rgba(var(--font-supportive), 1);
	border-radius: 100px;
	padding: 8px 12px;
`;

const Features = ({ title, features }: { title: string; features: GameTag[] }) => {
	return (
		<FeaturesContainer>
			<FeaturesTitle>{title}</FeaturesTitle>
			<FeaturesPillWrapper>
				{features.map(feature => (
					<FeaturePill key={feature.name}>{feature.name}</FeaturePill>
				))}
			</FeaturesPillWrapper>
		</FeaturesContainer>
	);
};

export default Features;
